import { render, staticRenderFns } from "./ArrayView.vue?vue&type=template&id=3670ac8c&scoped=true"
import script from "./ArrayView.vue?vue&type=script&lang=js"
export * from "./ArrayView.vue?vue&type=script&lang=js"
import style0 from "./ArrayView.vue?vue&type=style&index=0&id=3670ac8c&prod&scoped=true&lang=css"
import style1 from "./ArrayView.vue?vue&type=style&index=1&id=3670ac8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3670ac8c",
  null
  
)

export default component.exports